import React, { MutableRefObject, Ref, useState } from 'react';

export const useCombinedRefs = <T,>(ref1: Ref<T>, ref2?: Ref<T>) => {
   const targetRef = React.useRef<T | null>(null);

   React.useEffect(() => {
      [ref1, ref2].forEach(ref => {
         if (!ref) return;

         if (typeof ref === 'function') {
            // eslint-disable-next-line @typescript-eslint/ban-types
            (ref as Function)(targetRef.current);
         } else {
            (ref as MutableRefObject<T | null>).current = targetRef.current;
         }
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [targetRef]);

   return targetRef;
};
